import { useEffect, useRef, useCallback } from 'react';
export function useInterval(callback, delay, options) {
    if (options === void 0) { options = {}; }
    var _a = options.enabled, enabled = _a === void 0 ? true : _a, _b = options.immediate, immediate = _b === void 0 ? false : _b;
    var savedCallback = useRef(callback);
    var intervalId = useRef();
    // Remember the latest callback
    useEffect(function () {
        savedCallback.current = callback;
    }, [callback]);
    // Set up the interval
    var start = useCallback(function () {
        if (!enabled || delay === null) {
            return;
        }
        if (immediate) {
            savedCallback.current();
        }
        intervalId.current = setInterval(function () {
            savedCallback.current();
        }, delay);
        return function () {
            if (intervalId.current) {
                clearInterval(intervalId.current);
            }
        };
    }, [delay, enabled, immediate]);
    // Set up the interval initially
    useEffect(function () {
        return start();
    }, [start]);
    // Cleanup on unmount
    useEffect(function () {
        return function () {
            if (intervalId.current) {
                clearInterval(intervalId.current);
            }
        };
    }, []);
    // Return methods to control the interval
    return {
        start: start,
        stop: function () {
            if (intervalId.current) {
                clearInterval(intervalId.current);
            }
        },
        restart: function () {
            if (intervalId.current) {
                clearInterval(intervalId.current);
            }
            start();
        },
    };
}
